import styled from "styled-components";
import { calculateResponsiveSize } from "helpers/calculateResponsiveSize";
import { mediaMax } from "helpers/mediaQueries";

export const Wrapper = styled.div`
  position: relative;
`;

export const Row = styled.div`
  display: flex;
  margin-bottom: ${calculateResponsiveSize(120)};
  padding-left: 11vw;
  ${mediaMax("tabletLandscape")} {
    flex-direction: column-reverse;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 50%;
  ${mediaMax("tabletLandscape")} {
    width: 100%;
  }
`;

export const CopyWrapper = styled.div`
  ${mediaMax("tabletLandscape")} {
    padding: 24px 20px 48px 0;
  }
`;
